//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AddressClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    search(q: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Address/search?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    searchFull(q: string | null | undefined): Promise<Address[]> {
        let url_ = this.baseUrl + "/api/Address/searchFull?";
        if (q !== undefined && q !== null)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchFull(_response);
        });
    }

    protected processSearchFull(response: Response): Promise<Address[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Address[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Address[]>(null as any);
    }
}

export class BookingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    addBooking(booking: CreateBookingDTO): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Booking";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(booking);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddBooking(_response);
        });
    }

    protected processAddBooking(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getBookingsByDate(startDate: string, endDate: string): Promise<ViewBookingDTO[]> {
        let url_ = this.baseUrl + "/api/Booking/bydate/{startDate}/{endDate}";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined.");
        url_ = url_.replace("{startDate}", encodeURIComponent("" + startDate));
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined.");
        url_ = url_.replace("{endDate}", encodeURIComponent("" + endDate));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBookingsByDate(_response);
        });
    }

    protected processGetBookingsByDate(response: Response): Promise<ViewBookingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ViewBookingDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewBookingDTO[]>(null as any);
    }

    getCovidBookings(): Promise<ViewBookingDTO[]> {
        let url_ = this.baseUrl + "/api/Booking/covid";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCovidBookings(_response);
        });
    }

    protected processGetCovidBookings(response: Response): Promise<ViewBookingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ViewBookingDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewBookingDTO[]>(null as any);
    }

    getSalivaBookings(): Promise<ViewBookingDTO[]> {
        let url_ = this.baseUrl + "/api/Booking/saliva";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSalivaBookings(_response);
        });
    }

    protected processGetSalivaBookings(response: Response): Promise<ViewBookingDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ViewBookingDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewBookingDTO[]>(null as any);
    }

    getBooking(bookingId: string): Promise<ViewBookingDTO> {
        let url_ = this.baseUrl + "/api/Booking/{bookingId}";
        if (bookingId === undefined || bookingId === null)
            throw new Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetBooking(_response);
        });
    }

    protected processGetBooking(response: Response): Promise<ViewBookingDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ViewBookingDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewBookingDTO>(null as any);
    }

    deleteBooking(bookingId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Booking/{bookingId}";
        if (bookingId === undefined || bookingId === null)
            throw new Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteBooking(_response);
        });
    }

    protected processDeleteBooking(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    testReferral(): Promise<void> {
        let url_ = this.baseUrl + "/api/Booking/testreferral";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTestReferral(_response);
        });
    }

    protected processTestReferral(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    test(): Promise<void> {
        let url_ = this.baseUrl + "/api/Booking/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAvailability(day: string, locationId: string): Promise<AvailabilityDTO> {
        let url_ = this.baseUrl + "/api/Booking/{locationId}/{day}";
        if (day === undefined || day === null)
            throw new Error("The parameter 'day' must be defined.");
        url_ = url_.replace("{day}", encodeURIComponent("" + day));
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAvailability(_response);
        });
    }

    protected processGetAvailability(response: Response): Promise<AvailabilityDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AvailabilityDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailabilityDTO>(null as any);
    }
}

export class DayPassClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    checkIn(viewModel: CheckInRequestViewModel): Promise<Location> {
        let url_ = this.baseUrl + "/api/DayPass/CheckIn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheckIn(_response);
        });
    }

    protected processCheckIn(response: Response): Promise<Location> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Location;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Location>(null as any);
    }
}

export class DependantsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    createDependant(vm: CreateDependantViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Dependants";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateDependant(_response);
        });
    }

    protected processCreateDependant(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getDependants(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Dependants";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDependants(_response);
        });
    }

    protected processGetDependants(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class FormDataClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    getLocations(): Promise<Region[]> {
        let url_ = this.baseUrl + "/api/FormData/locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocations(_response);
        });
    }

    protected processGetLocations(response: Response): Promise<Region[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Region[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Region[]>(null as any);
    }

    getRegions(): Promise<Region[]> {
        let url_ = this.baseUrl + "/api/FormData/regions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRegions(_response);
        });
    }

    protected processGetRegions(response: Response): Promise<Region[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Region[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Region[]>(null as any);
    }

    getLocationHierarchy(locationId: string): Promise<Location[]> {
        let url_ = this.baseUrl + "/api/FormData/locations/{locationId}/hierarchy";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocationHierarchy(_response);
        });
    }

    protected processGetLocationHierarchy(response: Response): Promise<Location[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Location[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Location[]>(null as any);
    }
}

export class QuestionnaireClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    getQuestionnaires(): Promise<{ key: string; value: string; }[]> {
        let url_ = this.baseUrl + "/api/Questionnaire/GetQuestionnaires";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaires(_response);
        });
    }

    protected processGetQuestionnaires(response: Response): Promise<{ key: string; value: string; }[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewQuestionnaireResponseVm;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ key: string; value: string; }[]>(null as any);
    }

    getQuestions(): Promise<NewQuestionnaireResponseVm> {
        let url_ = this.baseUrl + "/api/Questionnaire/GetQuestions/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestions(_response);
        });
    }

    protected processGetQuestions(response: Response): Promise<NewQuestionnaireResponseVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewQuestionnaireResponseVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewQuestionnaireResponseVm>(null as any);
    }

    getQuestionnaireEmailByResponse(responseID: string): Promise<string> {
        let url_ = this.baseUrl + "/api/Questionnaire/GetQuestionnaireEmailByResponse/?responseId=" + responseID;
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireByResponse(_response);
        });
    }

    protected processGetQuestionnaireByResponse(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    createResponse(viewModel: CreateQuestionnaireViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Questionnaire";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateResponse(_response);
        });
    }

    protected processCreateResponse(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createNewResponse(questionnaireId: string, personId: string): Promise<NewQuestionnaireResponse> {
        let url_ = this.baseUrl + "/api/Questionnaire/{questionnaireId}/createResponse/{personId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewResponse(_response);
        });
    }

    protected processCreateNewResponse(response: Response): Promise<NewQuestionnaireResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewQuestionnaireResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewQuestionnaireResponse>(null as any);
    }

    createNewResponseForQueueWorkItem(questionnaireId: string, personId: string, queueWorkItemId: string): Promise<NewQuestionnaireResponse> {
        let url_ = this.baseUrl + "/api/Questionnaire/{questionnaireId}/createResponse/{personId}/{queueWorkItemId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (queueWorkItemId === undefined || queueWorkItemId === null)
            throw new Error("The parameter 'queueWorkItemId' must be defined.");
        url_ = url_.replace("{queueWorkItemId}", encodeURIComponent("" + queueWorkItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewResponseForQueueWorkItem(_response);
        });
    }

    protected processCreateNewResponseForQueueWorkItem(response: Response): Promise<NewQuestionnaireResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NewQuestionnaireResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NewQuestionnaireResponse>(null as any);
    }

    attachDependant(questionnaireId: string, dependantId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Questionnaire/{questionnaireId}/dependant/{dependantId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (dependantId === undefined || dependantId === null)
            throw new Error("The parameter 'dependantId' must be defined.");
        url_ = url_.replace("{dependantId}", encodeURIComponent("" + dependantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAttachDependant(_response);
        });
    }

    protected processAttachDependant(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteDependant(questionnaireId: string, dependantId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Questionnaire/{questionnaireId}/dependant/{dependantId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (dependantId === undefined || dependantId === null)
            throw new Error("The parameter 'dependantId' must be defined.");
        url_ = url_.replace("{dependantId}", encodeURIComponent("" + dependantId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteDependant(_response);
        });
    }

    protected processDeleteDependant(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addQuestionChoice(questionnaireId: string, questionId: string, vm: QuestionResponseVm): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Questionnaire/{questionnaireId}/{questionId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddQuestionChoice(_response);
        });
    }

    protected processAddQuestionChoice(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addQuestionChoiceByAdmin(questionnaireId: string, questionId: string, personId: string, vm: QuestionResponseVm): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Questionnaire/{questionnaireId}/{questionId}/{personId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddQuestionChoiceByAdmin(_response);
        });
    }

    protected processAddQuestionChoiceByAdmin(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    finaliseQuestionnaire(questionnaireId: string): Promise<FinaliseResultViewModel> {
        let url_ = this.baseUrl + "/api/Questionnaire/{questionnaireId}/finalise";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinaliseQuestionnaire(_response);
        });
    }

    protected processFinaliseQuestionnaire(response: Response): Promise<FinaliseResultViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinaliseResultViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinaliseResultViewModel>(null as any);
    }

    finaliseQuestionnaireByAdmin(queueWorkItemId: string, questionnaireId: string): Promise<FinaliseResultViewModel> {
        let url_ = this.baseUrl + "/api/Questionnaire/{queueWorkItemId}/{questionnaireId}/finalise";
        if (queueWorkItemId === undefined || queueWorkItemId === null)
            throw new Error("The parameter 'queueWorkItemId' must be defined.");
        url_ = url_.replace("{queueWorkItemId}", encodeURIComponent("" + queueWorkItemId));
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFinaliseQuestionnaireByAdmin(_response);
        });
    }

    protected processFinaliseQuestionnaireByAdmin(response: Response): Promise<FinaliseResultViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FinaliseResultViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FinaliseResultViewModel>(null as any);
    }

    validateQuestionnaire(responseId: string): Promise<QuestionValidationError[]> {
        let url_ = this.baseUrl + "/api/Questionnaire/validate/{responseId}";
        if (responseId === undefined || responseId === null)
            throw new Error("The parameter 'responseId' must be defined.");
        url_ = url_.replace("{responseId}", encodeURIComponent("" + responseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processValidateQuestionnaire(_response);
        });
    }

    protected processValidateQuestionnaire(response: Response): Promise<QuestionValidationError[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionValidationError[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionValidationError[]>(null as any);
    }
}

export class ReferralClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    createReferral(referral: CreateReferralDTO): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Referral";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(referral);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateReferral(_response);
        });
    }

    protected processCreateReferral(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    userInfo(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUserInfo(_response);
        });
    }

    protected processUserInfo(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    authGate(viewModel: LoginUserViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/gate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAuthGate(_response);
        });
    }

    protected processAuthGate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    login(returnUrl: string | null | undefined, kind: PersonKind | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/login?";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (kind === null)
            throw new Error("The parameter 'kind' cannot be null.");
        else if (kind !== undefined)
            url_ += "kind=" + encodeURIComponent("" + kind) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    loginCallback(returnUrl: string | null | undefined, kind: PersonKind | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/process?";
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (kind === null)
            throw new Error("The parameter 'kind' cannot be null.");
        else if (kind !== undefined)
            url_ += "kind=" + encodeURIComponent("" + kind) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processLoginCallback(_response);
        });
    }

    protected processLoginCallback(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AudiencesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    getAudiences(): Promise<AudienceViewModel[]> {
        let url_ = this.baseUrl + "/api/_admin/Audiences";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAudiences(_response);
        });
    }

    protected processGetAudiences(response: Response): Promise<AudienceViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AudienceViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AudienceViewModel[]>(null as any);
    }
}

export class AuditClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    getAuditReasons(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Audit/reasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuditReasons(_response);
        });
    }

    protected processGetAuditReasons(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class LocationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    getLocations(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Locations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocations(_response);
        });
    }

    protected processGetLocations(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createNewLocation(vm: NewLocationViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewLocation(_response);
        });
    }

    protected processCreateNewLocation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLocation(locationId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Locations/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLocation(_response);
        });
    }

    protected processGetLocation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    editLocation(locationId: string, vm: NewLocationViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Locations/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditLocation(_response);
        });
    }

    protected processEditLocation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteLocation(locationId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Locations/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLocation(_response);
        });
    }

    protected processDeleteLocation(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getQrCodesDump(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Locations/qr-export";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQrCodesDump(_response);
        });
    }

    protected processGetQrCodesDump(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PersonsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    getPerson(personId: string): Promise<PersonInfoViewModel> {
        let url_ = this.baseUrl + "/api/_admin/Persons/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPerson(_response);
        });
    }

    protected processGetPerson(response: Response): Promise<PersonInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonInfoViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonInfoViewModel>(null as any);
    }

    editPerson(personId: string, editModel: PersonEditModel): Promise<void> {
        let url_ = this.baseUrl + "/api/_admin/Persons/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditPerson(_response);
        });
    }

    protected processEditPerson(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    searchPersons(vm: PersonSearchQueryViewModel): Promise<PersonViewModel[]> {
        let url_ = this.baseUrl + "/api/_admin/Persons/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchPersons(_response);
        });
    }

    protected processSearchPersons(response: Response): Promise<PersonViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonViewModel[]>(null as any);
    }

    registerUser(viewModel: LoginUserViewModel): Promise<UserResponse> {
        let url_ = this.baseUrl + "/api/_admin/Persons/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(viewModel);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRegisterUser(_response);
        });
    }

    protected processRegisterUser(response: Response): Promise<UserResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserResponse>(null as any);
    }
}

export class QuestionnairesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    getQuestionnaires(): Promise<BasicQuestionnaireViewModel[]> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaires(_response);
        });
    }

    protected processGetQuestionnaires(response: Response): Promise<BasicQuestionnaireViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BasicQuestionnaireViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BasicQuestionnaireViewModel[]>(null as any);
    }

    createQuestionnaire(edit: QuestionnaireEditModel): Promise<string> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(edit);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateQuestionnaire(_response);
        });
    }

    protected processCreateQuestionnaire(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getQuestionnaire(questionnaireId: string): Promise<FullQuestionnaireViewModel> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaire(_response);
        });
    }

    protected processGetQuestionnaire(response: Response): Promise<FullQuestionnaireViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FullQuestionnaireViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FullQuestionnaireViewModel>(null as any);
    }

    editQuestionnaire(questionnaireId: string, edit: QuestionnaireEditModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(edit);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditQuestionnaire(_response);
        });
    }

    protected processEditQuestionnaire(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    cloneQuestionnaire(questionnaireId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}/clone";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCloneQuestionnaire(_response);
        });
    }

    protected processCloneQuestionnaire(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    publishQuestionnaire(questionnaireId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}/publish";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishQuestionnaire(_response);
        });
    }

    protected processPublishQuestionnaire(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getQuestions(questionnaireResponseId: string): Promise<QuestionnaireAndResponsesVm> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/questionsAndResponses/{questionnaireResponseId}";
        if (questionnaireResponseId === undefined || questionnaireResponseId === null)
            throw new Error("The parameter 'questionnaireResponseId' must be defined.");
        url_ = url_.replace("{questionnaireResponseId}", encodeURIComponent("" + questionnaireResponseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestions(_response);
        });
    }

    protected processGetQuestions(response: Response): Promise<QuestionnaireAndResponsesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireAndResponsesVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireAndResponsesVm>(null as any);
    }

    getQuestionnaireForPersonKind(personKind: PersonKind): Promise<string> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/questionnaireForKind/{personKind}";
        if (personKind === undefined || personKind === null)
            throw new Error("The parameter 'personKind' must be defined.");
        url_ = url_.replace("{personKind}", encodeURIComponent("" + personKind));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireForPersonKind(_response);
        });
    }

    protected processGetQuestionnaireForPersonKind(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getQuestionsByQuestionnaireId(id: string): Promise<QuestionAdminViewModel[]> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{id}/questionsbyquestionnaireid";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionsByQuestionnaireId(_response);
        });
    }

    protected processGetQuestionsByQuestionnaireId(response: Response): Promise<QuestionAdminViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionAdminViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionAdminViewModel[]>(null as any);
    }

    updateQuestion(questionnaireId: string, questionId: string, vm: BasicQuestionViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}/questions/{questionId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateQuestion(_response);
        });
    }

    protected processUpdateQuestion(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteQuestion(questionnaireId: string, questionId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}/questions/{questionId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteQuestion(_response);
        });
    }

    protected processDeleteQuestion(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createQuestion(questionnaireId: string, vm: BasicQuestionViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}/questions";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateQuestion(_response);
        });
    }

    protected processCreateQuestion(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createNewQuestionChoice(questionnaireId: string, questionId: string, vm: BasicQuestionChoiceViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}/questions/{questionId}/choices";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewQuestionChoice(_response);
        });
    }

    protected processCreateNewQuestionChoice(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateQuestionChoice(questionnaireId: string, questionId: string, choiceId: string, vm: QuestionChoiceViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}/questions/{questionId}/choices/{choiceId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        if (choiceId === undefined || choiceId === null)
            throw new Error("The parameter 'choiceId' must be defined.");
        url_ = url_.replace("{choiceId}", encodeURIComponent("" + choiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateQuestionChoice(_response);
        });
    }

    protected processUpdateQuestionChoice(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteQuestionChoice(questionnaireId: string, questionId: string, choiceId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}/questions/{questionId}/choices/{choiceId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        if (choiceId === undefined || choiceId === null)
            throw new Error("The parameter 'choiceId' must be defined.");
        url_ = url_.replace("{choiceId}", encodeURIComponent("" + choiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteQuestionChoice(_response);
        });
    }

    protected processDeleteQuestionChoice(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createUpdateQuestionChoiceAlertPOST(questionnaireId: string, questionId: string, choiceId: string, vm: ChoiceAlert): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}/questions/{questionId}/choices/{choiceId}/alert";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        if (choiceId === undefined || choiceId === null)
            throw new Error("The parameter 'choiceId' must be defined.");
        url_ = url_.replace("{choiceId}", encodeURIComponent("" + choiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUpdateQuestionChoiceAlertPOST(_response);
        });
    }

    protected processCreateUpdateQuestionChoiceAlertPOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createUpdateQuestionChoiceAlertPATCH(questionnaireId: string, questionId: string, choiceId: string, vm: ChoiceAlert): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}/questions/{questionId}/choices/{choiceId}/alert";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        if (choiceId === undefined || choiceId === null)
            throw new Error("The parameter 'choiceId' must be defined.");
        url_ = url_.replace("{choiceId}", encodeURIComponent("" + choiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUpdateQuestionChoiceAlertPATCH(_response);
        });
    }

    protected processCreateUpdateQuestionChoiceAlertPATCH(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteQuestionChoiceAlert(questionnaireId: string, questionId: string, choiceId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}/questions/{questionId}/choices/{choiceId}/alert";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        if (choiceId === undefined || choiceId === null)
            throw new Error("The parameter 'choiceId' must be defined.");
        url_ = url_.replace("{choiceId}", encodeURIComponent("" + choiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteQuestionChoiceAlert(_response);
        });
    }

    protected processDeleteQuestionChoiceAlert(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createResponseMapping(questionnaireId: string, questionId: string, choiceId: string, nextQuestionId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}/questions/{questionId}/choices/{choiceId}/mapping/{nextQuestionId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        if (choiceId === undefined || choiceId === null)
            throw new Error("The parameter 'choiceId' must be defined.");
        url_ = url_.replace("{choiceId}", encodeURIComponent("" + choiceId));
        if (nextQuestionId === undefined || nextQuestionId === null)
            throw new Error("The parameter 'nextQuestionId' must be defined.");
        url_ = url_.replace("{nextQuestionId}", encodeURIComponent("" + nextQuestionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateResponseMapping(_response);
        });
    }

    protected processCreateResponseMapping(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteResponseMapping(questionnaireId: string, questionId: string, choiceId: string, nextQuestionId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{questionnaireId}/questions/{questionId}/choices/{choiceId}/mapping/{nextQuestionId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        if (choiceId === undefined || choiceId === null)
            throw new Error("The parameter 'choiceId' must be defined.");
        url_ = url_.replace("{choiceId}", encodeURIComponent("" + choiceId));
        if (nextQuestionId === undefined || nextQuestionId === null)
            throw new Error("The parameter 'nextQuestionId' must be defined.");
        url_ = url_.replace("{nextQuestionId}", encodeURIComponent("" + nextQuestionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteResponseMapping(_response);
        });
    }

    protected processDeleteResponseMapping(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getQuestionnaireResponsesForUser(userId: string, questionnaireId: string | undefined): Promise<KeyValuePairOfGuidAndString[]> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/questionnairesForUser/{userId}?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireResponsesForUser(_response);
        });
    }

    protected processGetQuestionnaireResponsesForUser(response: Response): Promise<KeyValuePairOfGuidAndString[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValuePairOfGuidAndString[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyValuePairOfGuidAndString[]>(null as any);
    }

    adminSearchPerson(query: string | null | undefined): Promise<KeyValuePairOfGuidAndString[]> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/adminSearchPerson?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAdminSearchPerson(_response);
        });
    }

    protected processAdminSearchPerson(response: Response): Promise<KeyValuePairOfGuidAndString[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as KeyValuePairOfGuidAndString[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KeyValuePairOfGuidAndString[]>(null as any);
    }

    getExports(questionnaireId: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/exports?";
        if (questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' cannot be null.");
        else if (questionnaireId !== undefined)
            url_ += "questionnaireId=" + encodeURIComponent("" + questionnaireId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExports(_response);
        });
    }

    protected processGetExports(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getExportsForWorkItems(questionnaireId: string, queueWorkItemIds: string[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/exportsforqueueworkitems/{questionnaireId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queueWorkItemIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetExportsForWorkItems(_response);
        });
    }

    protected processGetExportsForWorkItems(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCSVExportForWorkItemId(queueId: string, questionnaireId: string, csvExport: CSVExportViewModel): Promise<QueueViewModel> {
        let url_ = this.baseUrl + "/api/_admin/Questionnaires/{queueId}/{questionnaireId}/export";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(csvExport);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCSVExportForWorkItemId(_response);
        });
    }

    protected processGetCSVExportForWorkItemId(response: Response): Promise<QueueViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueueViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueueViewModel>(null as any);
    }
}

export class QueueClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    getAllQueues(): Promise<QueueViewModel[]> {
        let url_ = this.baseUrl + "/api/_admin/Queue";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllQueues(_response);
        });
    }

    protected processGetAllQueues(response: Response): Promise<QueueViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueueViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueueViewModel[]>(null as any);
    }

    getQueueWorkItems(queueId: string, start: number | undefined, end: number | undefined, vm: SearchQueueWorkItemsViewModel): Promise<QueueViewModel> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItems?";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQueueWorkItems(_response);
        });
    }

    protected processGetQueueWorkItems(response: Response): Promise<QueueViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueueViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueueViewModel>(null as any);
    }

    getQueueWorkItem(queueId: string, workItemId: string): Promise<QueueWorkItemViewModel> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItems/{workItemId}";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQueueWorkItem(_response);
        });
    }

    protected processGetQueueWorkItem(response: Response): Promise<QueueWorkItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueueWorkItemViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueueWorkItemViewModel>(null as any);
    }

    getQueueMetrics(queueId: string, vm: SearchQueueWorkItemsViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/metrics";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQueueMetrics(_response);
        });
    }

    protected processGetQueueMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAllQueueMetrics(vm: SearchAllQueueWorkItemsViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/metrics";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllQueueMetrics(_response);
        });
    }

    protected processGetAllQueueMetrics(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    assignQueueWorkItem(queueId: string, workItemId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItems/{workItemId}/assignToMe";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignQueueWorkItem(_response);
        });
    }

    protected processAssignQueueWorkItem(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    unAssignQueueWorkItem(queueId: string, workItemId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItems/{workItemId}/unassign";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnAssignQueueWorkItem(_response);
        });
    }

    protected processUnAssignQueueWorkItem(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    unassignItemFromQueue(queueId: string, workItemId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItems/{workItemId}/unassign";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnassignItemFromQueue(_response);
        });
    }

    protected processUnassignItemFromQueue(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateQueueWorkItemStatus(queueId: string, workItemId: string, vm: UpdateQueueWorkItemViewModel): Promise<QueueWorkItemViewModel> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItems/{workItemId}/updateStatus";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateQueueWorkItemStatus(_response);
        });
    }

    protected processUpdateQueueWorkItemStatus(response: Response): Promise<QueueWorkItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueueWorkItemViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueueWorkItemViewModel>(null as any);
    }

    queueWorkItemOnHold(queueId: string, workItemId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItems/{workItemId}/onHold";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processQueueWorkItemOnHold(_response);
        });
    }

    protected processQueueWorkItemOnHold(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveQueueWorkItemNote(queueId: string, workItemId: string, vm: QueueWorkItemNoteViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItems/{workItemId}/saveNote";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSaveQueueWorkItemNote(_response);
        });
    }

    protected processSaveQueueWorkItemNote(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    assignItemToNewQueue(preQueueId: string, workItemId: string, assignment: AssignToQueueViewModel): Promise<number> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{preQueueId}/workItems/{workItemId}/assign";
        if (preQueueId === undefined || preQueueId === null)
            throw new Error("The parameter 'preQueueId' must be defined.");
        url_ = url_.replace("{preQueueId}", encodeURIComponent("" + preQueueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assignment);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAssignItemToNewQueue(_response);
        });
    }

    protected processAssignItemToNewQueue(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getQueueWorkItemNotes(queueId: string, workItemId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItems/{workItemId}/notes";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQueueWorkItemNotes(_response);
        });
    }

    protected processGetQueueWorkItemNotes(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getQueueWorkItemQuestions(queueId: string, workItemId: string): Promise<QuestionnaireResponseViewModel> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItems/{workItemId}/questions";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQueueWorkItemQuestions(_response);
        });
    }

    protected processGetQueueWorkItemQuestions(response: Response): Promise<QuestionnaireResponseViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireResponseViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireResponseViewModel>(null as any);
    }

    getQueueWorkItemAuditEvents(queueId: string, workItemId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItems/{workItemId}/auditEvents";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQueueWorkItemAuditEvents(_response);
        });
    }

    protected processGetQueueWorkItemAuditEvents(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getWorkItemFiles(queueId: string, workItemId: string): Promise<WorkItemFileViewModel[]> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItem/{workItemId}/files";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetWorkItemFiles(_response);
        });
    }

    protected processGetWorkItemFiles(response: Response): Promise<WorkItemFileViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkItemFileViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkItemFileViewModel[]>(null as any);
    }

    addFile(queueId: string, workItemId: string, filename: string, global: boolean | undefined, body: Blob | undefined): Promise<WorkItemFileViewModel> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItem/{workItemId}/file/{filename}?";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (global === null)
            throw new Error("The parameter 'global' cannot be null.");
        else if (global !== undefined)
            url_ += "global=" + encodeURIComponent("" + global) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddFile(_response);
        });
    }

    protected processAddFile(response: Response): Promise<WorkItemFileViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkItemFileViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkItemFileViewModel>(null as any);
    }

    getFile(queueId: string, workItemId: string, filename: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItem/{workItemId}/file/{filename}";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteFile(queueId: string, workItemId: string, filename: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItem/{workItemId}/file/{filename}";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteFile(_response);
        });
    }

    protected processDeleteFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAllQueuesForEdit(): Promise<ViewQueueViewModel[]> {
        let url_ = this.baseUrl + "/api/_admin/Queue/editqueues";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllQueuesForEdit(_response);
        });
    }

    protected processGetAllQueuesForEdit(response: Response): Promise<ViewQueueViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ViewQueueViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ViewQueueViewModel[]>(null as any);
    }

    getQueueForEdit(queueId: string): Promise<EditQueueViewModel> {
        let url_ = this.baseUrl + "/api/_admin/Queue/editqueues/{queueId}";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQueueForEdit(_response);
        });
    }

    protected processGetQueueForEdit(response: Response): Promise<EditQueueViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EditQueueViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditQueueViewModel>(null as any);
    }

    editQueue(queueId: string, vw: EditQueueViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/editqueue/{queueId}";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vw);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processEditQueue(_response);
        });
    }

    protected processEditQueue(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addQueue(vw: EditQueueViewModel): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/addqueue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vw);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddQueue(_response);
        });
    }

    protected processAddQueue(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getQueueOutcomes(): Promise<{ [key: string]: QueueChoiceVm[]; }> {
        let url_ = this.baseUrl + "/api/_admin/Queue/outcomes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQueueOutcomes(_response);
        });
    }

    protected processGetQueueOutcomes(response: Response): Promise<{ [key: string]: QueueChoiceVm[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: QueueChoiceVm[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: QueueChoiceVm[]; }>(null as any);
    }

    getUserOutcomesOutcome(outcomeId: string): Promise<Person[]> {
        let url_ = this.baseUrl + "/api/_admin/Queue/useroutcomes/{outcomeId}";
        if (outcomeId === undefined || outcomeId === null)
            throw new Error("The parameter 'outcomeId' must be defined.");
        url_ = url_.replace("{outcomeId}", encodeURIComponent("" + outcomeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUserOutcomesOutcome(_response);
        });
    }

    protected processGetUserOutcomesOutcome(response: Response): Promise<Person[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Person[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Person[]>(null as any);
    }

    setUserOutcomes(vm: UserOutcomeViewModel[]): Promise<UserOutcomeViewModel[]> {
        let url_ = this.baseUrl + "/api/_admin/Queue/adduseroutcomes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetUserOutcomes(_response);
        });
    }

    protected processSetUserOutcomes(response: Response): Promise<UserOutcomeViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserOutcomeViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserOutcomeViewModel[]>(null as any);
    }

    removeUserOutcome(vm: UserOutcomeViewModel[]): Promise<UserOutcomeViewModel[]> {
        let url_ = this.baseUrl + "/api/_admin/Queue/removeuseroutcomes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveUserOutcome(_response);
        });
    }

    protected processRemoveUserOutcome(response: Response): Promise<UserOutcomeViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserOutcomeViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserOutcomeViewModel[]>(null as any);
    }

    setFileFlags(queueId: string, workItemId: string, filename: string, global: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/{queueId}/workItem/{workItemId}/fileflag/{filename}?";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        if (filename === undefined || filename === null)
            throw new Error("The parameter 'filename' must be defined.");
        url_ = url_.replace("{filename}", encodeURIComponent("" + filename));
        if (global === null)
            throw new Error("The parameter 'global' cannot be null.");
        else if (global !== undefined)
            url_ += "global=" + encodeURIComponent("" + global) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetFileFlags(_response);
        });
    }

    protected processSetFileFlags(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getQueueOutcomesByQueueId(queueId: string | undefined): Promise<QueueChoiceVm[]> {
        let url_ = this.baseUrl + "/api/_admin/Queue/queueId/choices?";
        if (queueId === null)
            throw new Error("The parameter 'queueId' cannot be null.");
        else if (queueId !== undefined)
            url_ += "queueId=" + encodeURIComponent("" + queueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQueueOutcomesByQueueId(_response);
        });
    }

    protected processGetQueueOutcomesByQueueId(response: Response): Promise<QueueChoiceVm[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueueChoiceVm[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueueChoiceVm[]>(null as any);
    }

    getQuestionnaireByQueueId(queueId: string): Promise<string> {
        let url_ = this.baseUrl + "/api/_admin/Queue/questionnaireForQueue/{queueId}";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireByQueueId(_response);
        });
    }

    protected processGetQuestionnaireByQueueId(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getAllQuestionnaireResponse(queueId: string, workItemId: string): Promise<QuesitonnaireResponseListViewModel[]> {
        let url_ = this.baseUrl + "/api/_admin/Queue/questionnaireresponse/{queueId}/{workItemId}";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllQuestionnaireResponse(_response);
        });
    }

    protected processGetAllQuestionnaireResponse(response: Response): Promise<QuesitonnaireResponseListViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuesitonnaireResponseListViewModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuesitonnaireResponseListViewModel[]>(null as any);
    }

    getQuestionnaireResponse(queueId: string, workItemId: string, questionnaireResponseId: string): Promise<QuestionnaireResponseViewModel> {
        let url_ = this.baseUrl + "/api/_admin/Queue/questionnaireresponse/{queueId}/{workItemId}/{questionnaireResponseId}";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        if (workItemId === undefined || workItemId === null)
            throw new Error("The parameter 'workItemId' must be defined.");
        url_ = url_.replace("{workItemId}", encodeURIComponent("" + workItemId));
        if (questionnaireResponseId === undefined || questionnaireResponseId === null)
            throw new Error("The parameter 'questionnaireResponseId' must be defined.");
        url_ = url_.replace("{questionnaireResponseId}", encodeURIComponent("" + questionnaireResponseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireResponse(_response);
        });
    }

    protected processGetQuestionnaireResponse(response: Response): Promise<QuestionnaireResponseViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionnaireResponseViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireResponseViewModel>(null as any);
    }

    createNewQueueWorkItem(queueId: string, person: LoginUserViewModel): Promise<QueueWorkItemViewModel> {
        let url_ = this.baseUrl + "/api/_admin/Queue/newWorkItem/{queueId}";
        if (queueId === undefined || queueId === null)
            throw new Error("The parameter 'queueId' must be defined.");
        url_ = url_.replace("{queueId}", encodeURIComponent("" + queueId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(person);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateNewQueueWorkItem(_response);
        });
    }

    protected processCreateNewQueueWorkItem(response: Response): Promise<QueueWorkItemViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueueWorkItemViewModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueueWorkItemViewModel>(null as any);
    }

    sendEmailNotification(outcomes: QueueOutcomeViewModel[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Queue/sendNotificationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(outcomes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendEmailNotification(_response);
        });
    }

    protected processSendEmailNotification(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class RolesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    getRoles(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoles(_response);
        });
    }

    protected processGetRoles(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createRole(vm: Role): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateRole(_response);
        });
    }

    protected processCreateRole(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getRole(roleId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRole(_response);
        });
    }

    protected processGetRole(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateRole(roleId: string, vm: Role): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Roles/{roleId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vm);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateRole(_response);
        });
    }

    protected processUpdateRole(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getRoleMembers(roleId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Roles/{roleId}/members";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetRoleMembers(_response);
        });
    }

    protected processGetRoleMembers(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addRoleMember(roleId: string, personId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Roles/{roleId}/members/{personId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddRoleMember(_response);
        });
    }

    protected processAddRoleMember(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    removeRoleMember(roleId: string, personId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/Roles/{roleId}/members/{personId}";
        if (roleId === undefined || roleId === null)
            throw new Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRemoveRoleMember(_response);
        });
    }

    protected processRemoveRoleMember(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TestAdminClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://localhost:44357";
    }

    debug(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/_admin/TestAdmin/debug";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDebug(_response);
        });
    }

    protected processDebug(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface Address {
    countryRegion?: string | undefined;
    locality?: string | undefined;
    adminDistrict?: string | undefined;
    countryRegionIso2?: string | undefined;
    houseNumber?: string | undefined;
    postalCode?: string | undefined;
    addressLine?: string | undefined;
    streetName?: string | undefined;
    formattedAddress?: string | undefined;
}

export interface CreateBookingDTO {
    personId: string;
    thcid?: string | undefined;
    referralID?: string | undefined;
    bookingSlotId: string;
    bookingDate: string;
    type: BookingType;
}

export enum BookingType {
    Saliva = 0,
    Covid = 1,
}

export interface ViewBookingDTO {
    bookingId?: string | undefined;
    ipmBookingId?: string | undefined;
    bookingDate: string;
    locationId: string;
    locationName?: string | undefined;
    type: BookingType;
}

export interface AvailabilityDTO {
    date: string;
    locatioName?: string | undefined;
    locationId: string;
    bookingSlots?: BookingSlotDTO[] | undefined;
}

export interface BookingSlotDTO {
    id: string;
    startTime: string;
    endTime: string;
    availability: number;
}

export interface Location {
    id: string;
    name?: string | undefined;
    parentLocationId?: string | undefined;
    regionId?: string | undefined;
    hidden: boolean;
    children?: Location[] | undefined;
}

export interface CheckInRequestViewModel {
    locationId: string;
}

export interface CreateDependantViewModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface Region {
    id: string;
    name?: string | undefined;
    locations?: Location[] | undefined;
}

export interface NewQuestionnaireResponseVm {
    questions: QuestionAdminViewModel[];
    personId: string;
    questionnaireId: string;
    questionnaireResponseId: string;
    name: string;
}

export interface QuestionAdminViewModel {
    id: string;
    heading: string;
    type: QuestionType;
    hidden: boolean;
    required: boolean;
    intent: QuestionIntent;
    intentKey?: string | undefined;
    questionKey?: string | undefined;
    exportKey?: string | undefined;
    order: number;
    questionnaireId?: string | undefined;
    deletedAt?: string | undefined;
    choices: QuestionChoiceViewModel[];
    responseMappings: ResponseMappingViewModel[];
    subQuestions: SubQuestion[];
    info: HtmlSnippetViewModel[];
    nestedQuestions: QuestionAdminViewModel[];
    validation?: QuestionValidation | undefined;
}

export enum QuestionType {
    YesNo = 0,
    RadioButtons = 1,
    HasDependants = 2,
    RadioButtonsWithAddInfo = 3,
    TextField = 4,
    Repeater = 5,
    Grouped = 6,
    DateField = 7,
    DateTimeField = 8,
    Address = 9,
    RadioButtonsWithSearchFilter = 10,
    RadioButtonsWithLocationHelper = 11,
    MultiLineTextField = 12,
}

export enum QuestionIntent {
    None = 0,
    Metadata = 1,
}

export interface QuestionChoiceViewModel {
    id: string;
    text: string;
    outcomeResult: ChoiceResult;
    exportValue?: string | undefined;
    alert?: ChoiceAlert | undefined;
    order: number;
    deletedAt?: string | undefined;
    queueOutcomeChoiceId?: string | undefined;
    onAssignment: boolean;
}

export enum ChoiceResult {
    None = 0,
    TestRequired = 1,
    TraceRequired = 2,
    TraceAndTestRequired = 3,
    CreateHotlineWorkItem = 4,
    CreateCentralHubWorkItem = 5,
    CreatePheocWorkItem = 6,
}

export interface ChoiceAlert {
    id: string;
    title?: string | undefined;
    body?: string | undefined;
}

export interface ResponseMappingViewModel {
    choiceId: string;
    questionId: string;
    nextQuestionId?: string | undefined;
    deletedAt?: string | undefined;
}

export interface SubQuestion {
    id: string;
    text?: string | undefined;
    icon?: string | undefined;
}

export interface HtmlSnippetViewModel {
    id: string;
    text?: string | undefined;
}

export interface QuestionValidation {
    notBefore?: DateConstraint | undefined;
    notAfter?: DateConstraint | undefined;
    textType?: TextType | undefined;
}

export interface DateConstraint {
    fixed?: string | undefined;
    days?: number | undefined;
}

export enum TextType {
    Phone = 0,
    Email = 1,
}

export interface CreateQuestionnaireViewModel {
    locationId: string;
    resetMetadataQuestions: boolean;
}

export interface NewQuestionnaireResponse {
    id: string;
}

export interface QuestionResponseVm {
    choiceId: string;
    value?: string | undefined;
}

export interface FinaliseResultViewModel {
    status: QuestionnaireStatus;
    queueWorkItem?: QueueWorkItemViewModel | undefined;
}

export enum QuestionnaireStatus {
    None = 0,
    Completed = 1,
    TestRequired = 2,
    NoTestRequired = 3,
}

export interface QueueWorkItemViewModel {
    id: string;
    status: QueueWorkItemStatus;
    personAssignedTo?: PersonBasicViewModel | undefined;
    workItem: WorkItemViewModel;
    auditEvents?: AuditEventViewModel[] | undefined;
    notes?: QueueWorkItemNoteViewModel[] | undefined;
    queueId?: string | undefined;
    outcomes?: QueueOutcomeViewModel[] | undefined;
    nurse?: PersonViewModel | undefined;
}

export enum QueueWorkItemStatus {
    New = 0,
    Viewed = 1,
    PDFDownloaded = 2,
    AdminViewed = 3,
    AdminDownloaded = 4,
    AdminEdited = 5,
}

export interface PersonBasicViewModel {
    id: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    name?: string | undefined;
    currentAudience?: AudienceViewModel | undefined;
}

export interface AudienceViewModel {
    id: string;
    name?: string | undefined;
}

export interface WorkItemViewModel {
    id: string;
    person: PersonViewModel;
    createdAt: string;
    questionnaireResponse?: QuestionnaireWorkItemResponseViewModel | undefined;
    questionnaireResponseId: string;
}

export interface PersonViewModel {
    id: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    shortDateOfBirth?: string | undefined;
    emailAddress?: string | undefined;
    sex?: string | undefined;
    currentAudience?: AudienceViewModel | undefined;
}

export interface BasicQuestionnaireResponseViewModel {
    id: string;
    dayPass?: DayPassViewModel | undefined;
    status: QuestionnaireStatus;
    createdAt: string;
    completedAt?: string | undefined;
}

export interface QuestionnaireWorkItemResponseViewModel extends BasicQuestionnaireResponseViewModel {
    person?: PersonViewModel | undefined;
    questionResponses?: QuestionResponseViewModel[] | undefined;
}

export interface QuestionResponseViewModel {
    question?: BasicQuestionViewModel | undefined;
    questionChoice?: QuestionChoiceViewModel | undefined;
    questionChoiceId: string;
    createdAt: string;
    updatedAt?: string | undefined;
    value?: string | undefined;
}

export interface BasicQuestionViewModel {
    id: string;
    heading?: string | undefined;
    intent: QuestionIntent;
    type: QuestionType;
    order: number;
}

export interface DayPassViewModel {
    id: string;
    reference?: string | undefined;
    personId: string;
    type: DayPassType;
    additionalInstructions?: string | undefined;
    checkIns?: CheckInViewModel[] | undefined;
    createdAt: string;
    expires: string;
}

export enum DayPassType {
    Fail = 0,
    Normal = 1,
    Exemption = 2,
    Conditional = 3,
    TerminatedEarly = 4,
}

export interface CheckInViewModel {
    id: string;
    location?: LocationViewModel | undefined;
    type: CheckInType;
    createdAt: string;
}

export interface LocationViewModel {
    id: string;
    name?: string | undefined;
    parentLocationId?: string | undefined;
    covidLocation: boolean;
    hidden: boolean;
}

export enum CheckInType {
    None = 0,
    AdHoc = 1,
    Questionnaire = 2,
}

export interface AuditEventBaseViewModelOfAuditEventType {
    person?: PersonBasicViewModel | undefined;
    type: AuditEventType;
    message?: string | undefined;
    changedFields?: AuditFieldViewModel[] | undefined;
    auditEventReason?: AuditEventReason | undefined;
    createdAt: string;
}

export interface AuditEventViewModel extends AuditEventBaseViewModelOfAuditEventType {
}

export enum AuditEventType {
    None = 0,
    ChangedPassType = 1,
    LocationAdd = 2,
    LocationUpdate = 3,
    LocationRemove = 4,
    CreatedQuestionnaireQuestion = 5,
    UpdatedQuestionnaireQuestion = 6,
    DeletedQuestionnaireQuestion = 7,
    CreatedQuestionnaireChoice = 8,
    UpdatedQuestionnaireChoice = 9,
    DeletedQuestionnaireChoice = 10,
    CreatedQuestionnaireResponseMapping = 11,
    UpdatedQuestionnaireResponseMapping = 12,
    DeletedQuestionnaireResponseMapping = 13,
    CreatedChoiceAlert = 14,
    UpdatedChoiceAlert = 15,
    DeletedChoiceAlert = 16,
    QueueWorkItemStatusChanged = 17,
    QueueWorkItemAssigned = 18,
    QueueWorkItemUnAssigned = 19,
    QueueWorkItemNoteAdded = 20,
    QueueWorkItemCreated = 21,
}

export interface AuditFieldViewModel {
    fieldName?: string | undefined;
    newValue?: string | undefined;
    oldValue?: string | undefined;
}

export interface AuditEventReason {
    id: string;
    text?: string | undefined;
    additionalInformationRequired: boolean;
}

export interface QueueWorkItemNoteViewModel {
    id: string;
    person?: PersonBasicViewModel | undefined;
    createdAt: string;
    note?: string | undefined;
    global: boolean;
}

export interface QueueOutcomeViewModel {
    id: string;
    name?: string | undefined;
    notificationEmail?: string | undefined;
    filterable: boolean;
}

export interface QuestionValidationError {
    questionId: string;
    questionHeading?: string | undefined;
    message?: string | undefined;
    repeaterPath: number[];
}

export interface CreateReferralDTO {
    personId: string;
    person?: Person | undefined;
    thcId?: string | undefined;
    information?: string | undefined;
    referralType: ReferralType;
}

export interface Person {
    id: string;
    azureAdId?: string | undefined;
    firstName?: string | undefined;
    firstNameNormalised?: string | undefined;
    lastName?: string | undefined;
    lastNameNormalised?: string | undefined;
    contactNumber?: string | undefined;
    lastLocation?: Location | undefined;
    lastLocationId?: string | undefined;
    kind: PersonKind;
    accountType: AccountType;
    currentAudience?: Audience | undefined;
    currentAudienceId?: string | undefined;
    parentPersonId?: string | undefined;
    parentPerson?: Person | undefined;
    lastActive?: string | undefined;
    children?: Person[] | undefined;
    dayPasses?: DayPass[] | undefined;
    signIns?: SignIn[] | undefined;
    roles?: UserRole[] | undefined;
    queueOutcomeChoices?: QueueOutcomeChoice[] | undefined;
    dateOfBirth?: string | undefined;
    dependantFor?: QuestionnaireDependant[] | undefined;
    addresses?: PersonAddress[] | undefined;
    generalPractitioners?: PersonGeneralPractitioner[] | undefined;
    fullNameNormalised?: string | undefined;
    addressFull?: PersonAddress | undefined;
    sex?: string | undefined;
    emailAddress?: string | undefined;
}

export enum PersonKind {
    None = 0,
    Visitor = 1,
    Patient = 2,
    Staff = 3,
    QuarantineWorkerContractor = 4,
    QuarantineWorkerStaff = 5,
    HotLineStaff = 6,
    Public = 7,
    CentralHubStaff = 8,
    PHEOCStaff = 9,
}

export enum AccountType {
    None = 0,
    Guest = 1,
    Federated = 2,
    Dependant = 3,
}

export interface Audience {
    id: string;
    legacyType: PersonKind;
    name?: string | undefined;
    key?: string | undefined;
    isStaffAudience: boolean;
    questionnaireAudiences?: QuestionnaireAudience[] | undefined;
}

export interface QuestionnaireAudience {
    questionnaireId: string;
    questionnaire?: Questionnaire | undefined;
    audienceId: string;
    audience?: Audience | undefined;
}

export interface Questionnaire {
    id: string;
    name?: string | undefined;
    published: boolean;
    createdAt: string;
    updatedAt?: string | undefined;
    publishedAt?: string | undefined;
    audiences?: QuestionnaireAudience[] | undefined;
    roles?: QuestionnaireRole[] | undefined;
    questions?: Question[] | undefined;
    questionnaireQueues?: QuestionnaireQueue[] | undefined;
    questionnaireResponses?: QuestionnaireResponse[] | undefined;
}

export interface QuestionnaireRole {
    questionnaireId: string;
    questionnaire?: Questionnaire | undefined;
    roleId: string;
    role?: Role | undefined;
}

export interface Role {
    id: string;
    name?: string | undefined;
    permissions: Permissions;
}

export enum Permissions {
    SuperUser = 1,
    ModifyRoles = 2,
    ModifyLocations = 4,
    ModifyQuestions = 8,
    ModifyAudiences = 16,
    IgnoreLocationConstraints = 32,
    IgnoreAudienceConstraints = 64,
    ModifyDayPasses = 128,
    ViewQueues = 256,
}

export interface Question {
    id: string;
    heading?: string | undefined;
    type: QuestionType;
    intent: QuestionIntent;
    intentKey?: string | undefined;
    questionKey?: string | undefined;
    exportKey?: string | undefined;
    order: number;
    questionnaire?: Questionnaire | undefined;
    questionnaireId?: string | undefined;
    choices?: QuestionChoice[] | undefined;
    responseMappings?: ResponseMapping[] | undefined;
    subQuestions?: SubQuestion[] | undefined;
    info?: HtmlSnippet[] | undefined;
    nestedQuestions?: Question[] | undefined;
    parentQuestion?: Question | undefined;
    parentQuestionId?: string | undefined;
    required: boolean;
    hidden: boolean;
    validation?: QuestionValidation | undefined;
}

export interface QuestionChoice {
    id: string;
    text?: string | undefined;
    exportValue?: string | undefined;
    alert?: ChoiceAlert | undefined;
    queueOutcomeChoiceId?: string | undefined;
    queueOutcomeChoice?: QueueOutcomeChoice | undefined;
    onAssignment: boolean;
}

export interface QueueOutcomeChoice {
    id: string;
    queueId: string;
    queue?: Queue | undefined;
    name: string;
    description?: string | undefined;
    notificationEmail?: string | undefined;
    filterable: boolean;
    grouping?: string | undefined;
    assignable: boolean;
    createdAt: string;
    deletedAt?: string | undefined;
}

export interface Queue {
    id: string;
    name?: string | undefined;
    questionChoiceResult: ChoiceResult;
    queueWorkItems?: QueueWorkItem[] | undefined;
    outcomeChoices?: QueueOutcomeChoice[] | undefined;
    canAccessGlobalFiles: boolean;
    questionnaireQueues?: QuestionnaireQueue[] | undefined;
    canCreateForm: boolean;
    launchForm: boolean;
    formCreateHelpText?: string | undefined;
    canExportCSV: boolean;
    defaultExportQuestionnaireId?: string | undefined;
}

export interface QueueWorkItem {
    id: string;
    workItemId: string;
    workItem?: WorkItem | undefined;
    queue?: Queue | undefined;
    queueId: string;
    status: QueueWorkItemStatus;
    personAssignedTo?: Person | undefined;
    personAssignedToId?: string | undefined;
    auditEvents?: AuditEvent[] | undefined;
    notes?: QueueWorkItemNote[] | undefined;
    outcomes?: QueueWorkItemOutcome[] | undefined;
    queueWorkItemQuestionnaireResponses?: QueueWorkItemQuestionnaireResponse[] | undefined;
    parentGuardian?: Person | undefined;
}

export interface WorkItem {
    id: string;
    status: WorkItemStatus;
    createdAt: string;
    updatedAt?: string | undefined;
    queueWorkItems?: QueueWorkItem[] | undefined;
    questionnaireResponse?: QuestionnaireResponse | undefined;
    questionnaireResponseId: string;
}

export enum WorkItemStatus {
    None = 0,
    New = 1,
    Review = 2,
    Assigned = 3,
    Completed = 4,
}

export interface QuestionnaireResponse {
    id: string;
    person?: Person | undefined;
    personId: string;
    status: QuestionnaireStatus;
    audience?: Audience | undefined;
    audienceId?: string | undefined;
    questionnaire?: Questionnaire | undefined;
    questionnaireId?: string | undefined;
    createdAt: string;
    completedAt?: string | undefined;
    exportedAt?: string | undefined;
    exportId?: number | undefined;
    questionResponses?: QuestionResponse[] | undefined;
    questionnaireAudits?: AuditEvent[] | undefined;
    dependants?: QuestionnaireDependant[] | undefined;
    queueWorkItemQuestionnaireResponses?: QueueWorkItemQuestionnaireResponse[] | undefined;
}

export interface QuestionResponse {
    questionnaireResponse?: QuestionnaireResponse | undefined;
    questionnaireResponseId: string;
    question?: Question | undefined;
    questionId: string;
    questionChoice?: QuestionChoice | undefined;
    questionChoiceId: string;
    value?: string | undefined;
    createdAt: string;
    updatedAt?: string | undefined;
}

export interface AuditEvent {
    id: string;
    person?: Person | undefined;
    personId: string;
    type: AuditEventType;
    message?: string | undefined;
    queueWorkItem?: QueueWorkItem | undefined;
    queueWorkItemId?: string | undefined;
    questionnaireResponse?: QuestionnaireResponse | undefined;
    questionnaireResponseId?: string | undefined;
    questionnaire?: Questionnaire | undefined;
    questionnaireId?: string | undefined;
    auditEventReason?: AuditEventReason | undefined;
    auditEventReasonId?: string | undefined;
    changedFields?: AuditField[] | undefined;
    createdAt: string;
}

export interface AuditField {
    id: string;
    fieldName?: string | undefined;
    newValue?: string | undefined;
    oldValue?: string | undefined;
}

export interface QuestionnaireDependant {
    questionnaireResponseId: string;
    questionnaireResponse?: QuestionnaireResponse | undefined;
    dependantId: string;
    dependant?: Person | undefined;
    createdAt: string;
    deletedAt?: string | undefined;
}

export interface QueueWorkItemQuestionnaireResponse {
    id: string;
    questionnaireResponseId: string;
    questionnaireResponse?: QuestionnaireResponse | undefined;
    queueWorkItemId: string;
    queueWorkItem?: QueueWorkItem | undefined;
}

export interface QueueWorkItemNote {
    id: string;
    note?: string | undefined;
    global: boolean;
    person?: Person | undefined;
    personId: string;
    queueWorkItemId: string;
    queueWorkItem?: QueueWorkItem | undefined;
    createdAt: string;
}

export interface QueueWorkItemOutcome {
    queueWorkItemId: string;
    queueWorkItem?: QueueWorkItem | undefined;
    queueOutcomeChoiceId: string;
    queueOutcomeChoice?: QueueOutcomeChoice | undefined;
}

export interface QuestionnaireQueue {
    id: string;
    questionnaireId: string;
    questionnaire?: Questionnaire | undefined;
    queueId: string;
    queue?: Queue | undefined;
}

export interface ResponseMapping {
    choiceId: string;
    nextQuestionId?: string | undefined;
}

export interface HtmlSnippet {
    id: string;
    text?: string | undefined;
}

export interface DayPass {
    id: string;
    reference?: string | undefined;
    additionalInstructions?: string | undefined;
    person?: Person | undefined;
    personId: string;
    type: DayPassType;
    checkIns?: CheckIn[] | undefined;
    createdAt: string;
    expires: string;
}

export interface CheckIn {
    id: string;
    location?: Location | undefined;
    locationId: string;
    dayPassId: string;
    dayPass?: DayPass | undefined;
    type: CheckInType;
    createdAt: string;
}

export interface SignIn {
    id: string;
    person?: Person | undefined;
    personId: string;
    userAgent?: string | undefined;
    ipAddressRaw?: string | undefined;
    ipAddress?: IPAddress | undefined;
    ipAddressValue?: string | undefined;
}

export interface IPAddress {
    addressFamily: AddressFamily;
    scopeId: number;
    isIPv6Multicast: boolean;
    isIPv6LinkLocal: boolean;
    isIPv6SiteLocal: boolean;
    isIPv6Teredo: boolean;
    isIPv4MappedToIPv6: boolean;
    address: number;
}

export enum AddressFamily {
    Unspecified = 0,
    Unix = 1,
    InterNetwork = 2,
    ImpLink = 3,
    Pup = 4,
    Chaos = 5,
    NS = 6,
    Ipx = 6,
    Osi = 7,
    Iso = 7,
    Ecma = 8,
    DataKit = 9,
    Ccitt = 10,
    Sna = 11,
    DecNet = 12,
    DataLink = 13,
    Lat = 14,
    HyperChannel = 15,
    AppleTalk = 16,
    NetBios = 17,
    VoiceView = 18,
    FireFox = 19,
    Banyan = 21,
    Atm = 22,
    InterNetworkV6 = 23,
    Cluster = 24,
    Ieee12844 = 25,
    Irda = 26,
    NetworkDesigners = 28,
    Max = 29,
    Packet = 65536,
    ControllerAreaNetwork = 65537,
    Unknown = -1,
}

export interface UserRole {
    person?: Person | undefined;
    personId: string;
    role?: Role | undefined;
    roleId: string;
    canManageRoleMembers: boolean;
}

export interface PersonAddress {
    id: string;
    person?: Person | undefined;
    personId: string;
    createdAt: string;
    formattedAddress?: string | undefined;
    addressUnit?: string | undefined;
    addressLine?: string | undefined;
    suburb?: string | undefined;
    postcode?: string | undefined;
    state?: string | undefined;
    longitude: number;
    latitude: number;
}

export interface PersonGeneralPractitioner {
    id: string;
    person?: Person | undefined;
    personId: string;
    createdAt: string;
    name?: string | undefined;
    practice?: string | undefined;
}

export enum ReferralType {
    Saliva = 0,
    Covid = 1,
}

export interface LoginUserViewModel {
    firstName: string;
    lastName: string;
    contactNumber: string;
    dateOfBirth?: string | undefined;
    address?: string | undefined;
    addressFull?: AddressViewModel | undefined;
    gpName?: string | undefined;
    gpPractice?: string | undefined;
    longitude: number;
    latitude: number;
    kind: PersonKind;
    sex?: string | undefined;
    emailAddress?: string | undefined;
}

export interface AddressViewModel {
    addressUnit?: string | undefined;
    addressLine?: string | undefined;
    suburb?: string | undefined;
    postcode?: string | undefined;
    state?: string | undefined;
}

export interface NewLocationViewModel {
    name?: string | undefined;
    parentLocationId?: string | undefined;
    regionId?: string | undefined;
}

export interface PersonInfoViewModel {
    person?: PersonViewModel | undefined;
    questionnaires?: BasicQuestionnaireResponseViewModel[] | undefined;
}

export interface PersonSearchQueryViewModel {
    query?: string | undefined;
    accountType?: AccountType | undefined;
}

export interface UserResponse {
    user?: UserInfoViewModel | undefined;
}

export interface UserInfoViewModel {
    id: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    lastLocation?: Location[] | undefined;
    activePass?: DayPassViewModel2 | undefined;
    metadataQuestions?: MetadataQuestionsViewModel[] | undefined;
    kind: PersonKind;
    roles?: Role[] | undefined;
    futureBookings?: ViewBookingDTO[] | undefined;
    queueOutcomeChoices?: string[] | undefined;
}

export interface DayPassViewModel2 {
    reference?: string | undefined;
    createdAt: string;
    expires: string;
    type: DayPassType;
    sites?: string[] | undefined;
    dependants?: string[] | undefined;
}

export interface MetadataQuestionsViewModel {
    question?: Question | undefined;
    questionChoice?: QuestionChoice | undefined;
}

export interface PersonEditModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    contactNumber?: string | undefined;
    dateOfBirth: string;
    address?: string | undefined;
    addressFull?: AddressViewModel | undefined;
    generalPractitionerName?: string | undefined;
    generalPractitionerPractice?: string | undefined;
}

export interface BasicQuestionnaireViewModel {
    id: string;
    name?: string | undefined;
    published: boolean;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
}

export interface FullQuestionnaireViewModel {
    id: string;
    name: string;
    published: boolean;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    audiences: QuestionnaireAudienceViewModel[];
    questions: QuestionAdminViewModel[];
    queueOutcomes?: QueueOutcomeViewModel[] | undefined;
}

export interface QuestionnaireAudienceViewModel {
    audienceId: string;
    audience?: AudienceViewModel | undefined;
}

export interface QuestionnaireEditModel {
    name: string;
    audiences: string[];
    questions: QuestionEditModel[];
}

export interface QuestionEditModel {
    id?: string | undefined;
    heading: string;
    type: QuestionType;
    intent: QuestionIntent;
    intentKey?: string | undefined;
    questionKey?: string | undefined;
    exportKey?: string | undefined;
    hidden: boolean;
    required: boolean;
    choices: QuestionChoiceEditModel[];
    subQuestions: SubQuestionEditModel[];
    nestedQuestions?: QuestionEditModel[] | undefined;
    validation?: QuestionValidation | undefined;
}

export interface QuestionChoiceEditModel {
    id?: string | undefined;
    text: string;
    outcomeResult: ChoiceResult;
    nextQuestionId?: string | undefined;
    exportValue?: string | undefined;
    queueOutcomeChoiceId?: string | undefined;
    onAssignment: boolean;
}

export interface SubQuestionEditModel {
    id?: string | undefined;
    text?: string | undefined;
    icon?: string | undefined;
}

export interface QuestionnaireAndResponsesVm {
    questions: QuestionAdminViewModel[];
    personId: string;
    questionnaireId: string;
    name: string;
    responses: { [key: string]: QuestionResponseVm; };
    completedAt?: string | undefined;
}

export interface BasicQuestionChoiceViewModel {
    id: string;
    text: string;
    outcomeResult: ChoiceResult;
}

export interface KeyValuePairOfGuidAndString {
    key: string;
    value: string;
}

export interface QueueViewModel {
    id: string;
    name: string;
    queueWorkItems?: QueueWorkItemViewModel[] | undefined;
    canCreateForm: boolean;
    launchForm: boolean;
    formCreateHelpText?: string | undefined;
    canExportCSV: boolean;
    defaultExportQuestionnaireId?: string | undefined;
}

export interface CSVExportViewModel {
    startDateTime: string;
    endDateTime: string;
    reExportRecords: boolean;
}

export interface SearchQueueWorkItemsViewModel {
    query?: string | undefined;
    queueWorkItemStatuses?: QueueWorkItemStatus[] | undefined;
    before?: string | undefined;
    after?: string | undefined;
    outcomes?: string[] | undefined;
    currentUserViewableOutcomes?: string[] | undefined;
    isSuperUser: boolean;
}

export interface SearchAllQueueWorkItemsViewModel {
    before?: string | undefined;
    after?: string | undefined;
}

export interface UpdateQueueWorkItemViewModel {
    note?: string | undefined;
    status: QueueWorkItemStatus;
}

export interface AssignToQueueViewModel {
    newQueueId: string;
    outcomeIds: string[];
}

export interface QuestionnaireResponseViewModel extends BasicQuestionnaireResponseViewModel {
    person?: PersonViewModel | undefined;
    questionResponses?: QuestionResponseViewModel[] | undefined;
    questionnaireAudits?: AuditEventViewModel[] | undefined;
    dependants?: QuestionnaireDependantViewModel[] | undefined;
}

export interface QuestionnaireDependantViewModel {
    dependant?: PersonViewModel | undefined;
    createdAt: string;
    deletedAt?: string | undefined;
}

export interface WorkItemFileViewModel {
    filename: string;
    length: number;
    global: boolean;
    queueId: string;
}

export interface ViewQueueViewModel {
    id: string;
    name?: string | undefined;
}

export interface EditQueueViewModel {
    name?: string | undefined;
    canAccessGlobalFiles: boolean;
    queueOutcomes?: EditQueueChoiceVm[] | undefined;
    defaultForm?: string | undefined;
    canCreateForm: boolean;
    launchForm: boolean;
    formCreateHelpText?: string | undefined;
    questionnaires: string[];
    canExportCSV: boolean;
    defaultCSVQuestionnaireId?: string | undefined;
    notificationEmail?: string | undefined;
}

export interface EditQueueChoiceVm {
    id?: string | undefined;
    name: string;
    description?: string | undefined;
    notificationEmail?: string | undefined;
    filterable: boolean;
    assignable: boolean;
    grouping?: string | undefined;
}

export interface QueueChoiceVm {
    id: string;
    name: string;
    description?: string | undefined;
    filterable: boolean;
    assignable: boolean;
    grouping?: string | undefined;
    children?: QueueChoiceVm[] | undefined;
    parentId?: string | undefined;
}

export interface UserOutcomeViewModel {
    queueOutcomeChoiceId: string;
    personId: string;
}

export interface QuesitonnaireResponseListViewModel {
    id: string;
    questionnaireName?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}